class MobileMenuDetails extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.backButton = this.querySelector("[data-mobile-back-btn]");

    const handleTrigger = (e) => {
      e.preventDefault();
      e.stopPropagation();

      this._toggle();
    };

    this.summary.addEventListener("click", handleTrigger);

    this.backButton.addEventListener("click", (e) => {
      e.preventDefault();
      this._close();
    });

    document.addEventListener("menu:close", () => {
      this._close();
    });
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _open() {
    this.details.open = true;

    setTimeout(() => {
      this.details.classList.add("open");
    }, 300);
  }

  _close() {
    this.details.classList.remove("open");

    setTimeout(() => {
      this.details.open = false;
    }, 300);
  }
}

if (!customElements.get("mobile-menu-details")) {
  customElements.define("mobile-menu-details", MobileMenuDetails);
}
